/* eslint-disable camelcase */
import { useState } from 'react'

import moment from 'moment'

import { AnimalsSecured } from '../../Types/AnimalStore'
import { PRICE_TYPE } from '../../constants/priceType'
import { Minus, Plus } from '../Icons'
import { ActionsCell, Cell, Row } from '../TablePacks/styles'
import { ExpandRow } from './ExpandRow'
import { RowInsuredButton } from './styles'

type RowInsuredProps = {
  data: AnimalsSecured
}

export const RowInsured = ({ data }: RowInsuredProps) => {
  const [open, setOpen] = useState(false)

  const handleExpandClick = (item: any) => {
    setOpen((prev) => !prev)
  }

  return (
    <>
      <Row style={{ borderBottom: open ? 'none' : '1px solid #cccccc' }}>
        <Cell>
          <div className="truncate">{data.name}</div>€{data.pack?.price}/
          {PRICE_TYPE?.[data.pack?.installment as never]}
        </Cell>
        <Cell>{moment(data.birthDate).format('DD-MM-YYYY')}</Cell>
        <Cell>{data.breed}</Cell>
        <Cell>{data.pack?.name ?? '-'}</Cell>
        <ActionsCell>
          <RowInsuredButton onClick={() => handleExpandClick(data)}>
            {open ? <Minus /> : <Plus />}
          </RowInsuredButton>
        </ActionsCell>
      </Row>
      {open && <ExpandRow data={data} />}
    </>
  )
}
